import { Component } from '@angular/core';
import { LoaderService } from '@affinite/common';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
  constructor(public loader: LoaderService) { }
}
